import React from 'react';

function PageContainerNoLogo({ children }) {
  return (
    <div className="page">
      {children}
    </div>
  );
}

export default PageContainerNoLogo;;